import { Injectable } from '@angular/core';
import { BaseStoreService } from '@src/app/modules/base';

import { CollectionStatistics } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class LpCollectionStatisticsStoreService extends BaseStoreService<CollectionStatistics> {}
